import { render, staticRenderFns } from "./HorizontalSidebar.vue?vue&type=template&id=07cd2add&"
import script from "./HorizontalSidebar.vue?vue&type=script&lang=js&"
export * from "./HorizontalSidebar.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VContainer,VNavigationDrawer})
